//@ts-check
import { useMemo } from 'react';

import useServicesBySdkCodes from './useServicesBySdkCodes';

/**
 * @param {import('@action-types/ecApp').AppDetails} appDetails
 * @param {import('@tanstack/react-query').UseQueryOptions & {filterDuplicates: boolean}} [options]
 */
const useEcAppSdkCodes = (appDetails, options) => {
  const sdkCodes = appDetails?.sdks?.map((sdk) => sdk?.sdkCode);
  const filterDuplicates = options?.filterDuplicates ?? true;
  const servicesQuery = useServicesBySdkCodes(sdkCodes, {
    ...(options ?? {}),
    enabled: sdkCodes?.length > 0,
  });

  // Sometimes Console API returns duplicate services for the same sdk code
  const data = useMemo(() => {
    if (filterDuplicates && servicesQuery.data?.services?.length > 0) {
      const services = servicesQuery.data.services.filter((service) => {
        // Filter out disabled services
        if (!service?.enabled) {
          return false;
        }

        // Find services with the same sdkcode and product profiles
        const duplicates = servicesQuery.data.services.filter((s) => {
          if (s?.code !== service.code) {
            return false;
          }

          return service.properties?.licenseConfigs?.every((lc) =>
            s?.properties?.licenseConfigs?.some((slc) => slc?.productId === lc?.productId)
          );
        });

        // If there are duplicates, check if it is the first one in the list
        return duplicates[0].id === service.id;
      });
      return { ...servicesQuery.data, services };
    }
    return servicesQuery.data;
  }, [filterDuplicates, servicesQuery.data]);

  return { ...servicesQuery, data };
};

export default useEcAppSdkCodes;
